/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import {installWindowOnGlobal} from './dom-shim.js';
installWindowOnGlobal();
